/** 機能オプション */
export const FEATURE_OPTIONS = {
  /** スクリーニング・可視化システム */
  screeningAuth: 'ScreeningAuth', // screening利用に必須
  /** 応急危険度判定 */
  emergencyAuth: 'EmergencyAuth', // screening利用に必須
  /** 自己判定 */
  selfJudgeAuth: 'SelfJudgeAuth',
  /** 帳票出力ツール */
  formToolAuth: 'FormToolAuth',
  /** 平面図 */
  floorPlanAuth: 'FloorPlanAuth',
  /** 支援台帳 */
  supportAuth: 'SupportAuth',
  /** 台帳側印刷機能 */
  supportPrintAuth: 'SupportPrintAuth',
  /** オンライン申請 */
  onlineAppAuth: 'OnlineAppAuth',
} as const
